import Area, { IArea } from "./Area";
import Application from "../Application";
import { IRouter } from "../runtime/Router";
import RegisteredApplicantsPage from "../ui/pages/applicants/RegisteredApplicantsPage";
import ShowRegisteredApplicantsInteractor from "../interactor/applicants/ShowRegisteredApplicantsInteractor";
import RegisteredApplicantDetailsPage from "../ui/pages/applicants/RegisteredApplicantDetailsPage";
import ShowRegisteredApplicantDetailsInteractor from "../interactor/applicants/ShowRegisteredApplicantDetailsInteractor";
import ShowApplicantFormDetailsInteractor from "../interactor/applicants/ShowApplicantFormDetailsInteractor";
import ApplicantFormDetails from "../ui/pages/applicants/details/ApplicantFormDetails";
import { RoleConstants } from "../common/Constants";

export default class ApplicantsArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor(application: Application, router: IRouter) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes(
      {
        path: "/registered-applicants",
        page: this.createPage({
          Page: RegisteredApplicantsPage,
          action: this.showRegisteredApplicantsPage.bind(this)
        }),
        options: {
          secure: true,
          role: [
            RoleConstants.MIK_BO.MIK_ADMIN,
            RoleConstants.MIK_BO.MIK_OSOBLJE,
            RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS
          ]
        }
      },
      {
        path: "/registered-applicants/:applicantId/details",
        page: this.createPage({
          Page: RegisteredApplicantDetailsPage,
          action: this.showRegisteredApplicantDetailsPage.bind(this)
        }),
        options: {
          secure: true,
          role: [
            RoleConstants.MIK_BO.MIK_OSOBLJE,
            RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS
          ]
        }
      },
      {
        path: "/registered-applicants/:applicantId/details/:tabKey",
        page: this.createPage({
          Page: RegisteredApplicantDetailsPage,
          action: this.showRegisteredApplicantDetailsPage.bind(this)
        }),
        options: {
          secure: true,
          role: [
            RoleConstants.MIK_BO.MIK_OSOBLJE,
            RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS
          ]
        }
      },
      {
        path: "/registered-applicants/:applicantId/details/forms/:formId",
        page: this.createPage({
          Page: ApplicantFormDetails,
          action: this.showApplicantFormDetails.bind(this)
        }),
        options: {
          secure: true,
          role: [
            RoleConstants.MIK_BO.MIK_OSOBLJE,
            RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS
          ]
        }
      }
    );
  }

  public showRegisteredApplicantsPage() {
    return this.application.container
      .resolve<ShowRegisteredApplicantsInteractor>("showRegisteredApplicants")
      .execute();
  }

  public showRegisteredApplicantDetailsPage(params: any) {
    return this.application.container
      .resolve<ShowRegisteredApplicantDetailsInteractor>(
        "showRegisteredApplicantDetails"
      )
      .execute(parseInt(params.applicantId, 10), undefined, params.tabKey);
  }

  public showApplicantFormDetails(params: any) {
    return this.application.container
      .resolve<ShowApplicantFormDetailsInteractor>("showApplicantFormDetails")
      .execute(parseInt(params.formId, 10));
  }
}
